import {createFeatureSelector, createSelector} from "@ngrx/store";
import {TeamInfoState} from "@team/pages/infos/store/team-info.state";

export const teamInfoStoreSelect = createFeatureSelector<TeamInfoState>('teamInfos');

export const selectInfoPageList = createSelector(
  teamInfoStoreSelect,
  (state: TeamInfoState) => state.infoList
);

export const selectInfoPagePagination = createSelector(
  teamInfoStoreSelect,
  (state: TeamInfoState) => state.paging
);

export const selectInfoPageLoading = createSelector(
  teamInfoStoreSelect,
  (state: TeamInfoState) => state.isLoading
);

export const selectInfoPageLoadingId = createSelector(
  teamInfoStoreSelect,
  (state: TeamInfoState) => state.isLoadingId
);
